<div class="container-fluid">
  <div class="row dark py-3">
    <div class="col-md-12 text-center social">
      <a [href]="hLink.gitHubLink" target="_blank" title="GitHub"> <i class="bi bi-github"></i></a>

      <a [href]="hLink.linkedinLink" target="_blank" title="LinkedIn">
        <i class="bi bi-linkedin"></i>
      </a>

      <a [href]="hLink.hackerRankLink" target="_blank" title="HackerRank">
        <i class="bi bi-h-square-fill"></i
      ></a>

      <a [href]="hLink.twitterLink" target="_blank" title="Twitter">
        <i class="bi bi-twitter-x"></i
      ></a>

      <a [href]="hLink.instagramLink" target="_blank" title="Instagram">
        <i class="bi bi-instagram"></i>
      </a>

      <!-- <a [href]="hLink.facebookLink" target="_blank" title="Facebook">
        <i class="bi bi-facebook"></i>
      </a> -->

      <a [href]="hLink.stackOverflowLink" target="_blank" title="Stack Overflow">
        <i class="bi bi-stack-overflow"></i
      ></a>
    </div>
  </div>

  <div class="row bg-dark" *ngIf="isCopyrightContent">
    <div class="col-md-12">
      <div id="footer" class="text-center py-2 text-white">
        <p>
          Copyright &copy; Rohit Rana. Design by
          <a href="#" style="text-decoration: none">Rohit Rana</a>
        </p>
      </div>
    </div>
  </div>
</div>
